// 낮·밤이 함께 쓰는 고정 목양견 아트 레지스트리.
export const NIGHT_DOG_ART = Object.freeze([
  Object.freeze({ kind: 'seori', dayAssetBase: 'seori', nightKey: 'dog-seori',
    nightFile: 'art/allies/seori/v1/sheet-6x2.png' }),
  Object.freeze({ kind: 'baram', dayAssetBase: 'baram', nightKey: 'dog-baram',
    nightFile: 'art/allies/baram/v1/sheet-6x2.png' }),
]);

const BY_KIND = new Map(NIGHT_DOG_ART.map((dog) => [dog.kind, dog]));

export function dayDogAssetBase(kind) {
  return BY_KIND.get(kind)?.dayAssetBase ?? 'seori';
}

export function nightDogTexture(kind) {
  return BY_KIND.get(kind)?.nightKey ?? 'dog-seori';
}

export function dogVisualScale() {
  return 1;
}

export function dogArtFiles() {
  return NIGHT_DOG_ART.map((dog) => dog.nightFile);
}
